// Motion tokens — one vocabulary for the whole site.

// Entering/exiting UI: fast start, gentle settle.
export const EASE_OUT = [0.23, 1, 0.32, 1] as const;
// Things moving across the screen or looping in place.
export const EASE_IN_OUT = [0.77, 0, 0.175, 1] as const;

// Durations (seconds). No single element should exceed 0.3s.
export const DURATION = {
  press: 0.12,
  swap: 0.15,
  small: 0.2,
  enter: 0.3,
} as const;

// Hover nudges on cards and arrows: soft, no overshoot.
export const HOVER_SPRING = { type: 'spring', stiffness: 260, damping: 26 } as const;
// Playful grow on the case study arrow button: a touch of bounce.
export const BUTTON_SPRING = { type: 'spring', stiffness: 380, damping: 22 } as const;
// Sliding indicators (active nav pill, tab underline): quick and decisive.
export const INDICATOR_SPRING = { type: 'spring', stiffness: 500, damping: 40 } as const;
